export const pricesAttributes = [
  'price',
  'fee_monthly',
  'monthly_rent',
  'shared_debt',
  'deposit',
];
